module.exports = __webpack_public_path__ + "static/11-e6cb6a832ee5ae7526ce2fbbe2a8a862.jpg";